import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-mt-6 tw-flex tw-items-center tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: "order-cancel-container-modal",
    maxWidth: "md",
    onClose: _ctx.onCancel
  }, {
    title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createTextVNode("Cancel container", -1)
    ]))]),
    subtitle: _withCtx(() => [
      (_ctx.containerLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.containerLabel), 1))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(({ close }) => [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "tw-mb-3 tw-text-sm tw-text-slate-600" }, " This container will stay on the order but trips cannot be added or completed. ", -1)),
      _createVNode(_component_InputField, {
        id: "cancelledReason",
        label: "Cancellation reason",
        modelValue: _ctx.cancelledReasonInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cancelledReasonInput) = $event)),
        placeholder: "e.g. Not our drayage"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          isGreen: true,
          isPrimary: true,
          disabled: !_ctx.canSubmit,
          class: "tw-p-0",
          icon: "check",
          title: "Cancel container",
          "aria-label": "Cancel container",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Cancel container ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          isRed: true,
          isSecondary: true,
          class: "tw-p-0",
          title: "Close",
          "aria-label": "Close cancel container dialog",
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
}